module.exports = __webpack_public_path__ + "static/media/petanque.f033029c.png";